<template>
  <div id="editFeedEntry">
    <div class="form-group">
      <b-container class="pb-0 pt-0">
        <b-row>
          <label class="pl-0 col-3 defaultLabel"> Publiziert </label>
          <div class="col-9 pl-0">
            <v-flex
              sm12
              md6
            >
              <u-date-picker
                id="publishedFrom"
                v-model="itemCopy.publicationDate"
                label="Publiziert"
              />
            </v-flex>
          </div>
        </b-row>
        <b-row class="mt-4">
          <label class="pl-0 col-3 defaultLabel"> Tenants </label>
          <div class="col-9 pl-0 margin-Top-0">
            <v-checkbox
              v-model="itemCopy.tenants"
              class="w-25 blackLabel"
              label="gavservice.ch"
              :value="1"
              color="red"
              :disabled="editable || itemCopy.publicationId"
            />
            <v-checkbox
              v-model="itemCopy.tenants"
              class="w-25 blackLabel"
              label="tempdata"
              :value="2"
              color="red"
              :disabled="editable || itemCopy.publicationId"
            />
            <v-checkbox
              v-model="itemCopy.tenants"
              class="w-25 blackLabel"
              label="Unia"
              :value="4"
              color="red"
              :disabled="editable || itemCopy.publicationId"
            />
          </div>
        </b-row>
        <b-row class="mt-4">
          <label class="pl-0 col-3 defaultLabel"> Status </label>
          <div class="col-9 pl-0 margin-Top-0">
            <v-radio-group v-model="itemCopy.status">
              <v-radio
                v-for="(n, nindex) in status"
                :key="nindex"
                class="blackLabel"
                :label="n.text"
                :value="n.value"
                color="red"
              />
            </v-radio-group>
          </div>
        </b-row>
        <!-- Url can only be edited if its not a publication-rss-feed -->
        <b-row
          v-if="!itemCopy.publicationId"
          class="mt-4"
        >
          <label class="pl-0 col-3 defaultLabel"> Url </label>
          <div class="col-9 pl-0">
            <u-multiline-multilanguage-text-input
              id="shortMultiUrl"
              v-model="itemCopy.feedEntryContents"
              content-property-name="url"
              :readonly="!editable && itemCopy.publicationId"
            />
          </div>
        </b-row>
        <b-row class="mt-4">
          <label class="pl-0 col-3 defaultLabel"> Text </label>
          <div class="col-9 pl-0">
            <u-multiline-multilanguage-text-input
              id="shortMultiText"
              v-model="itemCopy.feedEntryContents"
              content-property-name="value"
              :readonly="!editable && itemCopy.publicationId"
            />
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import UDatePicker from "@/components/common/UDatePicker.vue";
export default {
  components: {
    UDatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      itemCopy: {},
      status: [
        { value: 1, text: "Entwurf" },
        { value: 2, text: "Publiziert" },
      ],
    };
  },
  watch: {
    itemCopy() {
      this.$emit("input", this.itemCopy);
    },
  },
  created() {
    this.itemCopy = JSON.parse(JSON.stringify(this.value));
  },
};
</script>

<style>
#editFeedEntry .blackLabel .theme--light.v-label {
  color: black;
}
#editFeedEntry .margin-Top-0 .v-input--selection-controls {
  margin-top: 0px;
}
</style>
